export const OFFICIAL_SALES_PHONE = '+34602070720'

const OFFICIAL_SALES_PHONE_WHATSAPP = OFFICIAL_SALES_PHONE.replace(/\D/g, '')

export const toOfficialSalesTelHref = () => `tel:${OFFICIAL_SALES_PHONE}`

export const toOfficialSalesWhatsAppHref = (message?: string) => {
    const base = `https://wa.me/${OFFICIAL_SALES_PHONE_WHATSAPP}`
    if (!message) return base
    return `${base}?text=${encodeURIComponent(message)}`
}
